/*
 * @Descripttion:
 * @version:
 * @Author: 周志国
 * @Date: 2025-09-09 09:39:13
 * @LastEditors: 周志国
 * @LastEditTime: 2025-09-09 09:45:58
 * @changeLog:
 * @FilePath: /anov-3d-webgl/packages/anov-3d-ability/src/business/Cylinder/interface.ts
 */
import type { Mesh } from '@anov/3d-core'
import type { options } from './types'
export interface ICylinder {
  /**
   * 创建圆柱体
   * @param options - 参数配置
   * @returns
   */
  createCylinder: (options: options) => Mesh
}